import React, { useState } from 'react';
import './CustomShareLinkCard.css';

const CustomShareLinkCard = ({ shareUrl = '' }) => {
  const [copied, setCopied] = useState(false);
  const canShare =
    typeof navigator !== 'undefined' && typeof navigator.share === 'function';

  const handleCopy = async () => {
    if (!shareUrl) return;
    try {
      await navigator.clipboard.writeText(shareUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      setCopied(false);
    }
  };

  const handleShare = async () => {
    if (!canShare || !shareUrl) return;
    try {
      await navigator.share({
        title: 'Zoomed In Custom',
        text: 'Play my custom Zoomed In puzzle',
        url: shareUrl,
      });
    } catch {
      // ignore cancel/failure
    }
  };

  if (!shareUrl) return null;

  return (
    <section className="custom-share-card">
      <div className="custom-share-card__title">Share Link</div>
      <input
        type="text"
        value={shareUrl}
        readOnly
        onFocus={(event) => event.target.select()}
        className="custom-share-card__input"
        aria-label="Share URL"
      />
      <div className="custom-share-card__actions">
        <button type="button" className="custom-share-card__btn" onClick={handleCopy}>
          {copied ? 'Copied!' : 'Copy Link'}
        </button>
        {canShare ? (
          <button type="button" className="custom-share-card__btn" onClick={handleShare}>
            Share
          </button>
        ) : null}
      </div>
    </section>
  );
};

export default CustomShareLinkCard;
